import useGlobalLocation from 'components/globalLocationSelector/hooks/useGlobalLocation';
import NavigationDrawer from 'components/navigation/NavigationDrawer.jsx';
import CircularLoader from 'components/UI/loaders/CircularLoader.jsx';
import { CONTROL_CENTAR_WEBSOKET } from 'config';
import { PermissionsProvider } from 'contexts/PermissionsContext';
import useComputedTitle from 'hooks/useComputedTitle';
import PropTypes from 'prop-types';
import { Suspense, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useMatches } from 'react-router-dom';
import { StompSessionProvider } from 'react-stomp-hooks';
import { webSocketConfig } from '../../config';

const AppLayout = ({ user, features }) => {
    const { selectedLocation } = useGlobalLocation();
    const matches = useMatches();

    const pageTitle = useMemo(() => {
        for (let i = matches.length - 1; i >= 0; i--) {
            const t = matches[i]?.handle?.pageTitle;
            if (t) return t;
        }
        return undefined;
    }, [matches]);

    const hasTopNavMiddleAdornment = useMemo(() => {
        for (let i = matches.length - 1; i >= 0; i--) {
            if (matches[i]?.handle?.topNavMiddleAdornment) return true;
        }
        return false;
    }, [matches]);

    const computedTitle = useComputedTitle({
        hasTopNavMiddleAdornment,
        pageTitle,
        selectedLocation,
    });

    return (
        <PermissionsProvider>
            <Helmet>
                <title>{computedTitle}</title>
            </Helmet>
            <StompSessionProvider
                url={CONTROL_CENTAR_WEBSOKET}
                reconnectDelay={webSocketConfig.reconnectDelay}
                connectionTimeout={webSocketConfig.connectionTimeout}
                heartbeatIncoming={webSocketConfig.heartbeatIncoming}
                heartbeatOutgoing={webSocketConfig.heartbeatOutgoing}
            >
                {!!user && <NavigationDrawer user={user} features={features} />}
                <Suspense fallback={<CircularLoader />}>
                    <Outlet />
                </Suspense>
            </StompSessionProvider>
        </PermissionsProvider>
    );
};

AppLayout.propTypes = {
    user: PropTypes.object.isRequired,
    features: PropTypes.array.isRequired,
};

export default AppLayout;
